import React from "react";
import { OffsetMeters, metersToFeet } from "../utils/geoOffset";
import styles from "../styles.module.scss";

interface Props {
  zoneName: string;
  offset: OffsetMeters;
  is3D?: boolean;
  onSave: () => void;
  onReset: () => void;
  onCancel: () => void;
}

const NudgePanel: React.FC<Props> = ({
  zoneName,
  offset,
  is3D,
  onSave,
  onReset,
  onCancel,
}) => {
  const feetX = metersToFeet(offset.dx);
  const feetY = metersToFeet(offset.dy);
  const ewLabel = feetX >= 0 ? "E" : "W";
  const nsLabel = feetY >= 0 ? "N" : "S";

  return (
    <div className={styles.nudgePanel}>
      <div className={styles.nudgePanelHeader}>
        Adjusting <strong>{zoneName}</strong>
      </div>
      <div className={styles.nudgePanelOffset}>
        Offset: {Math.abs(feetX).toFixed(1)} ft {ewLabel} ·{" "}
        {Math.abs(feetY).toFixed(1)} ft {nsLabel}
      </div>
      <div className={styles.nudgePanelHint}>
        {is3D
          ? "Click the sidebar first, then use arrow keys to move the polygon (Shift = 5 ft). Enter to save, Esc to cancel."
          : "Drag polygon, or use arrow keys (Shift = 5 ft). Enter to save, Esc to cancel."}
      </div>
      <div className={styles.nudgePanelActions}>
        <button className={styles.nudgeBtnGhost} onClick={onReset}>
          Reset
        </button>
        <button className={styles.nudgeBtnGhost} onClick={onCancel}>
          Cancel
        </button>
        <button className={styles.nudgeBtnPrimary} onClick={onSave}>
          Save offset
        </button>
      </div>
    </div>
  );
};

export default NudgePanel;
